import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lock\">\r\n    <path d=\"M2 5c.522-2.837 3.032-5 6-5 2.974 0 5.48 2.162 6.001 5H16v11H0V5h2zm2.064 0h7.934a3.885 3.885 0 0 0-3.802-3h-.292a3.941 3.941 0 0 0-3.84 3zM2 7v7h12V7H2zm5 2h2v3H7V9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol